import VPerfectSignature from './components/VPerfectSignature'

export {
  VPerfectSignature,
}

export default VPerfectSignature
